import { motion } from "framer-motion";
import { Percent } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { restaurantConfig } from "@/config/restaurantConfig";
import { localize } from "@/lib/format";

export function HeroBanner() {
  const { lang } = useLang();
  const promo = restaurantConfig.promotions?.[0];
  if (!promo) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative mx-4 overflow-hidden rounded-3xl shadow-float"
      data-testid="hero-banner"
    >
      <img
        src={promo.image}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/20 rtl:bg-gradient-to-l" />
      <div className="relative flex min-h-[148px] flex-col justify-center gap-2 p-6 pe-20">
        <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary px-3 py-1 text-xs font-bold text-primary-foreground">
          <Percent className="h-3.5 w-3.5" />
          {localize(promo.tag, lang)}
        </span>
        <h2 className="font-heading text-2xl font-extrabold leading-tight text-white">
          {localize(promo.title, lang)}
        </h2>
        <p className="text-sm leading-snug text-white/80">{localize(promo.subtitle, lang)}</p>
      </div>
    </motion.div>
  );
}
